import { z } from "zod";

export const buttonSizeThresholdConfigSchema = z.object({
  small: z.number().optional(),
  medium: z.number().optional(),
  large: z.number().optional(),
});

export type ButtonSizeThreshold = z.infer<
  typeof buttonSizeThresholdConfigSchema
>;
